// @dx hook
import { CrudFilters } from "@refinedev/core";
import { globalSearchDao } from "@services";

/**
 * Calls the global_search RPC for a specific entity and returns a CrudFilters
 * array that constrains the table to matching IDs.
 *
 * When the query is empty the filter array is empty (no constraint).
 */
export async function buildGlobalSearchFilter(
  query: string,
  entity: string
): Promise<CrudFilters> {
  const trimmed = query?.trim();
  if (!trimmed) return [];

  let hits: { id: number; id_text: string | null }[] = [];
  try {
    hits = await globalSearchDao.search(trimmed, [entity], 200);
  } catch {
    return [];
  }

  // id_text carries the real key for entities whose id isn't a bigint
  // (e.g. pipeline_extractions, keyed on document_extractions' uuid id).
  // Falls back to the numeric id for every existing (bigint-keyed) entity.
  const ids: (string | number)[] = hits.map((r) => r.id_text ?? r.id);

  if (ids.length === 0) {
    // No matches — return a filter that will yield zero rows
    return [{ field: "id", operator: "eq", value: -1 }];
  }

  return [{ field: "id", operator: "in", value: ids }];
}